export const handleLinkTracking = ({
  title,
  url,
  location,
  conversionType,
}) => {
  const link_click_event = new CustomEvent('track_link_location', {
    detail: {
      event: 'link-click',
      linkTitle: title,
      linkURL: url,
      linkLocation: location ? location : 'NA_link_location',
      linkConversionType: conversionType ? conversionType : 'NA',
    },
  });
  document.dispatchEvent(link_click_event);
};
